import { REFRESH_TOKEN_KEY, TOKEN_KEY } from './constants'

export const saveDataInStorage = (key: string, value: string) => {
  localStorage.setItem(key, value)
}

export const getDataFromStorage = (key: string) => localStorage.getItem(key)

export const removeDataFromStorage = (key: string) => {
  localStorage.removeItem(key)
}

export const clearStorage = () => {
  localStorage.clear()
}

export const clearCachedUser = () => {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(REFRESH_TOKEN_KEY)
}
